import { fetchApi } from '@/services/api-client';

export const MY_PROFILE_PATH = '/me/profile';

export type ProfileNationality = {
  code: string;
  name: string;
  flag: string;
};

export type MyProfile = {
  id: string;
  email: string;
  fullName: string | null;
  nickname: string | null;
  photoUrl: string;
  nationalities: ProfileNationality[];
  /** Notification mail only; the bell and transactional mail are unaffected. */
  notificationEmailsEnabled: boolean;
};

export type UpdateMyProfileData = {
  nickname?: string;
  photoUrl?: string;
  nationalities?: string[];
  notificationEmailsEnabled?: boolean;
};

export const myProfileApi = {
  get: () => fetchApi<MyProfile>(MY_PROFILE_PATH),
  update: (data: UpdateMyProfileData) =>
    fetchApi<MyProfile>(MY_PROFILE_PATH, { method: 'PATCH', body: JSON.stringify(data) }),
};

export const MY_TEACHER_PROFILE_PATH = '/me/teacher-profile';

export type TeacherProfileValues = {
  role: string;
  photoUrl: string;
  bio: string;
  qualifications: string[];
  certifications: string[];
};

export type TeacherSubmissionStatus = 'none' | 'pending' | 'rejected';

export type MyTeacherProfile = {
  teacherId: string | null;
  name: string;
  published: boolean;
  status: TeacherSubmissionStatus;
  reviewNote: string | null;
  pendingSubmittedAt: string | null;
  live: TeacherProfileValues;
  pending: TeacherProfileValues | null;
};

export const myTeacherProfileApi = {
  get: () => fetchApi<MyTeacherProfile>(MY_TEACHER_PROFILE_PATH),
  submit: (data: TeacherProfileValues) =>
    fetchApi<MyTeacherProfile>(MY_TEACHER_PROFILE_PATH, { method: 'PUT', body: JSON.stringify(data) }),
};
